import type {FacebookTagInPostVerificationAttemptData} from '@cohort/shared/apps/facebook/triggers/tagInPost';
import {Trans} from 'react-i18next';

const FacebookTagInPostTriggerStepCompletionTitleComponent: React.FC<{
  data: FacebookTagInPostVerificationAttemptData;
  completionSuccess: boolean;
}> = ({data}) => {
  return (
    <Trans
      i18nKey="triggers.tag-in-post.stepCompletionTitleComponent.success"
      ns="app-facebook"
      values={{username: data.username}}
    />
  );
};

export default FacebookTagInPostTriggerStepCompletionTitleComponent;
